import { Typography } from '@mui/material';

export function Copyright() {
    const year = new Date().getFullYear();
    return (
        <Typography variant='body2' sx={{ color: 'common.white' }}>
            © {year} Copyright Insight2Profit. All Rights Reserved.
        </Typography>
    );
}
